import type { FunctionComponent } from "react";

export const DKVMobilityLogo: FunctionComponent = () => {
  return (
    <img src="/images/brand/dkv-mobility-logo.svg" className={"h-10 w-auto"} alt="DKV Mobility" />
  );
};
